import { combineReducers } from '@reduxjs/toolkit'
import data from './dataSlice'

const registerReducer = combineReducers({
    data,
})

export default registerReducer
